
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.983 13.796C33.632 7.796 28.686 3 22.723 3c-3.62 0-7.126 1.775-9.298 4.672-.049-.026-.102-.043-.152-.068a5.753 5.753 0 00-1.044-.39c-.077-.021-.154-.043-.232-.06a5.963 5.963 0 00-.456-.083c-.068-.01-.134-.024-.203-.032A6.007 6.007 0 004.667 13c0 .087.004.171.01.255C1.905 14.765 0 17.933 0 21.103c0 4.722 3.841 8.564 8.563 8.564H12a.667.667 0 100-1.334H8.563c-3.986 0-7.23-3.243-7.23-7.23 0-2.77 1.804-5.644 4.288-6.836l.379-.18v-.42c0-.082.005-.166.01-.25l.006-.117-.008-.125C6.005 13.117 6 13.059 6 13a4.672 4.672 0 014.667-4.667c.206 0 .409.018.611.045a4.583 4.583 0 01.683.142c.022.007.046.01.068.017a4.576 4.576 0 01.695.281A4.663 4.663 0 0115.334 13a.667.667 0 101.333 0c0-1.836-.831-3.48-2.134-4.58 1.911-2.5 5.059-4.087 8.19-4.087 5.162 0 9.452 4.09 9.898 9.258-.681-.048-1.702-.072-2.722.084a.666.666 0 10.201 1.318c1.483-.224 3.029-.014 3.123-.002 3.104.59 5.444 3.45 5.444 6.657 0 3.686-3 6.685-6.686 6.685h-2.648a.666.666 0 100 1.334h2.648c4.422 0 8.019-3.598 8.019-8.019 0-3.66-2.551-6.941-6.017-7.852z","fill":"#3367D6"}}),_c('path',{attrs:{"d":"M21.139 20.53a.668.668 0 00-.944 0l-5.333 5.332a.666.666 0 10.943.943L20 22.608v13.724a.666.666 0 101.333 0V22.61l4.196 4.195a.665.665 0 00.942 0 .666.666 0 000-.942l-5.332-5.333z","fill":"#3367D6"}})])
          )
        }
      }
    